import 'url-polyfill'
import * as React from 'react'
import {createRoot} from 'react-dom/client'
import {QueryClientProvider, QueryClient} from '@tanstack/react-query'
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'
import {fromJust} from '@freckle/maybe'
import {setupI18n} from '@freckle/educator-entities/ts/common/helpers/translate/i18n/i18n-helper'
import bugsnagClient from '@freckle/school/ts/common/helpers/exception-handlers/bugsnag-client'
import {initializeGlobalEventListeners} from '@freckle/school/ts/common/routers/init-global-event-listeners'
import RouterV2 from '@freckle/school/ts/common/routers/router-v2'
// Important: Keep CSS import first to correctly order global CSS and CSS Modules
import './../css/freckle.scss'
import './main.scss'

setupI18n('school')

initializeGlobalEventListeners()

const container = fromJust(document.getElementById('freckle'), 'Container not found')

const ErrorBoundary = bugsnagClient.getPlugin('react')?.createErrorBoundary(React) as React.FC

const root = createRoot(container)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 100 // Debounce to prevent infinite refetching
    }
  }
})

root.render(
  // @ts-ignore: Cannot use `children` after React 18
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      {/* React Suspense is used for i18n helper here */}
      <React.Suspense fallback={null}>
        <RouterV2 />
      </React.Suspense>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </ErrorBoundary>
)
